import React, { useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { DescriptionBar, MenuTab } from 'components';
import TimeConversion from './TimeConversion';
import CoordinateTransformation from './CoordinateTransformation';
import { useTranslation } from 'react-i18next';
import TLEDataConverter from './TLEDataConverter';

const SpaceTimeTools = () => {
  const { t } = useTranslation();
  const [activeTab, setActiveTab] = useState<number>(0);

  const menuList = [
    'Time Conversion',
    'Coordinate Transformation',
    'TLE Data Converter'
  ];

  return (
    <>
      <Helmet>
        <title>SpaceTime Tools - IOPS SPACE</title>
        <meta name="description" content="Simple and accurate tools for converting time, coordinates, and satellite TLE data" />
      </Helmet>

      <div className="h-full w-[800px]">
        <DescriptionBar
          className="mb-2 md:pt-1"
          title="SpaceTime Tools"
          description="Simple and accurate tools for converting time, coordinates, and satellite TLE data"
        />
        <div className="w-full flex-1 flex flex-col">
          <MenuTab
            menuList={menuList}
            selectedMenuIndex={activeTab}
            onClickTab={setActiveTab}
          />
          <div className="flex-1 flex flex-col">
            {activeTab === 0 && <TimeConversion />}
            {activeTab === 1 && <CoordinateTransformation />}
            {activeTab === 2 && <TLEDataConverter />}
          </div>
        </div>
      </div>
    </>
  );
};

export default SpaceTimeTools;
